import React, { useState , useEffect } from 'react';
import ReCAPTCHA from "react-google-recaptcha";

import '../royal.css'; 

const CelebrityForm = () => {

  const [captchaValue, setCaptchaValue] = useState(null);
  
    const handleCaptchaChange = (value) => {
      console.log("Captcha value:", value);
      setCaptchaValue(value);
    };

   const [gclid, setGclid] = useState('');

     const [utmParams, setUtmParams] = useState({
      utm_source: '',
      utm_medium: '',
      utm_campaign: '',
      utm_term: '',
      utm_content: ''
    });
  

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    leadsource: "Celebrity Form",
    monthOfTravel: "",
    passengers: "",
    destination: "",
    utm_source: "",
    utm_medium: "",
    utm_campaign:"" ,
    utm_term:"",
    utm_content: "",
    zc_gad: ""
  });
  
  const [showPopup, setShowPopup] = useState(false);  
  const [loading, setLoading] = useState(false);  

  useEffect(() => {
      const params = new URLSearchParams(window.location.search);
     
      const queryParams = {};
for (const [key, value] of params.entries()) {
  queryParams[key.toLowerCase()] = value;
}

// Extract UTM parameters (case-insensitive)
const utm = {
  utm_source: queryParams['utm_source'] || '',
  utm_medium: queryParams['utm_medium'] || '',
  utm_campaign: queryParams['utm_campaign'] || '',
  utm_term: queryParams['utm_term'] || '',
  utm_content: queryParams['utm_content'] || ''
};
      
      const gclidValue = params.get('gclid') || '';
      setUtmParams(utm);
      setGclid(gclidValue);
  
     setFormData((prevData) => ({
      ...prevData,
      ...utm,
      zc_gad: gclidValue
    }));
  
    }, [gclid]);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaValue) {
      alert("Please verify you're not a robot.");
      return;
    }

      // Trimmed values
  const trimmedData = {
    firstName: formData.firstName.trim(),
    lastName: formData.lastName.trim(),
    email: formData.email.trim(),
    mobile: formData.mobile.trim(),
    destination: formData.destination.trim(),
  };

  // Check required fields for non-empty trimmed values
  if (
    !trimmedData.firstName ||
    !trimmedData.lastName ||
    !trimmedData.email ||
    !trimmedData.mobile ||
    !trimmedData.destination
  ) {
    alert("Please fill in all required fields properly.");
    return;
  }

    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }

    setLoading(true);  

    try {
      const response = await fetch("https://script.google.com/macros/s/AKfycbzR9luzYYnKfRc7aoTqosZKw4BOKSuAVL7-I5ZsDT4LCpHPuq7DDtyoaI05z-K6B5px/exec", {
        method: "POST",
        body: form
      });

      if (response.ok) {
        setShowPopup(true);  
      } else {
        alert("There was an error submitting the form.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error submitting form!");
    } finally {
      setLoading(false);  
    }
  };

  return (
    <div>
      <div className="form-container">
        <form onSubmit={handleSubmit} className="form-box">
          <h2 className="form-title">REQUEST A CELEBRITY CRUISE QUOTE</h2>

<div className="rowalign"> 
           <div className="form-group ">
            <label>First Name *</label>
            <input
              type="text"
              name="firstName"
              onChange={handleChange}
              placeholder="First Name"
              required
            />
          </div>

          <div className="form-group">
            <label>Last Name *</label>
            <input
              type="text"
              name="lastName"
              onChange={handleChange}
              placeholder="Last Name"
              required
            />

            </div>

            </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              onChange={handleChange}
              placeholder="Email"
              required
            />
          </div>

          <div className="form-group">
            <label>Phone *</label>
            <input
              type="tel"
              name="mobile"
              onChange={handleChange}
               placeholder="Phone"
              required
            />
          </div>

<div className="rowalign"> 
          <div className="form-group">
            <label>No. of Travellers</label>
            <input
              type="number"
              name="passengers"
              onChange={handleChange}
              placeholder="Number of Travellers"
            />
          </div>

          <div className="form-group">
            <label>Travel Month</label>
            <input
              type="date"
              name="monthOfTravel"
              onChange={handleChange}
            />
          </div>

          </div>

          <div className="form-group">
            <label>Destination *</label>
            <input
              type="text"
              name="destination"
              onChange={handleChange}
              placeholder="Destination"
              required
            />
          </div>


 <ReCAPTCHA
        sitekey="6LeU8oQrAAAAAOUZDRbGmAtO1a6rlMNP4zb8uUPU"
        onChange={handleCaptchaChange}
      />
          
          {/* Hidden UTM Fields */}
 <input type="hidden" name="utm_source" value={utmParams.utm_source} />
 <input type="hidden" name="utm_medium" value={utmParams.utm_medium} />
 <input type="hidden" name="utm_campaign" value={utmParams.utm_campaign} />
 <input type="hidden" name="utm_term" value={utmParams.utm_term} />
 <input type="hidden" name="utm_content" value={utmParams.utm_content} />
 <input type="hidden" id="zc_gad" name="zc_gad" value="" />

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Submitting...' : 'Submit'}
          </button>
        </form>
      </div>

      {/* Popup Animation */}
      {showPopup && (
        <div className="popup-container">
          <div className="popup-content">
            <h3>Thank you for your submission!</h3>
            <p>We will get back to you soon.</p>
            <button onClick={() => setShowPopup(false)} className="close-popup">Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CelebrityForm;
